import {FETCH_PRIVILEGES, GIVE_PRIVILEGES, FETCH_PRIVILEGES_WITH_REGIONS, GET_PRIVILEGES_WITH_REGIONS} from './types';
import axios from 'axios';
import {urlConfig} from "../config"
import OTTService from "../Services/OTTService";
import _ from 'lodash';
const baseAuthUrl = `${urlConfig.bffUrl}`;

function authResponseHandler(response) {
    return new Promise((resolve, reject) => {
        if (response.data) {
            if (response.data.status === "SUCCESS") {
                if (response.data.entity) {

                    let authResponse = response.data.entity;

                    let privileges = authResponse.privileges;

                    resolve(privileges);
                } else {
                    if (response.data.genericMessages && response.data.genericMessages.ERROR && response.data.genericMessages.ERROR.length > 0) {

                        let errorMessages = response.data.genericMessages;
                        reject(errorMessages);
                    }
                }
            } else {
                reject();
            }
        }
    })

}


function authWithRegionsHandler(response) {
    return new Promise((resolve, reject) => {
        authResponseHandler(response).then((authResponse) => {
            OTTService.getRegions().then((response) => {

                let privileges = authResponse;
                console.log(privileges);

                let regionWithRights = [];

                regionWithRights = getRegionWithRights(privileges);

                let regions = response.data;

                let newRegions = [];
                _.map(regions, (region) => {

                    let rightsFlag = false;
                    _.forEach(regionWithRights, (regionWithRight) => {

                        if (region.id == regionWithRight) {
                            rightsFlag = true;
                        }
                    });

                    if (rightsFlag === true) {
                        newRegions.push(region);
                    } else {

                    }

                });

                resolve({privileges:privileges,regions:regions});

            })
        })

    })
}

function getRegionWithRights(privileges) {
    let regions = [];
    _.map(privileges, (privilege) => {
        if (privilege.url && privilege.url === '/ott/list') {

        }
        if (privilege.url.endsWith("OTT")) {
            let url = privilege.url;
            let regionStringArray = url.split("_");
            if (privilege.url !== "Viu_OTT") {
                regions.push(regionStringArray[regionStringArray.length - 2]);
            }
        }
    });
    return regions;
}

export function fetchPrivileges(emailId) {

    return (dispatch) => axios.get(`${baseAuthUrl}/privilege/email?emailId=${emailId}`)
        .then((response) => {
            return authResponseHandler(response)
        }, error => {
        })
        .then(
            response => dispatch({type: 'FETCH_PRIVILEGES', payload: response}),
            error => dispatch({type: 'FETCH_PRIVILEGES', payload: error})
        )
}

export function fetchPrivilegesWithRegions(emailId) {

    return (dispatch) => axios.get(`${baseAuthUrl}/privilege/email?emailId=${emailId}`)
        .then((response) => {
            return authWithRegionsHandler(response)
        }, error => {
        })
        .then(
            response => dispatch({type: 'FETCH_PRIVILEGES_WITH_REGIONS', payload: response}),
            error => dispatch({type: 'FETCH_PRIVILEGES_WITH_REGIONS', payload: error})
        )
}

export function getPrivilegesWithRegions() {
    return (dispatch) => {
        dispatch({
            type: GET_PRIVILEGES_WITH_REGIONS,
        })
    }
}

export function givePrivileges() {
    return (dispatch) => {
        dispatch({
            type: GIVE_PRIVILEGES,
        })
    }
}
